import { media } from 'styled-bootstrap-grid'
import styled, { css } from 'styled-components'
import { animations } from '@ocean/ui'
import { Direction } from './WartsilaButtonWrapper'
import Logo from './assets/wartsila-logo.png'

const { blink } = animations.common

type WrapperProps = {
  inactive?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  display: inline-flex;
  flex-direction: column;

  ${({ inactive }) =>
    inactive &&
    `
    opacity: 0.6;
  `}
`

type ButtonWrapperProps = {
  direction?: Direction
  animated?: boolean
}

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  display: inline-flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 8px;
  border-bottom: none;

  button {
    width: 250px;

    ${media.sm`
      width: 300px;
    `}

    ${media.md`
      width: 190px;
    `}

    &:not(:first-child) {
      ${({ theme }) => `
        margin-top: ${theme.space.mobile.small};
      `}

      ${({ theme }) => media.md`
        margin-top: 0;
        margin-left: ${theme.space.desktop.small};
      `}
    }
  }

  &:before {
    content: '';
    display: none;
    position: absolute;
    height: 36px;
    width: 152px;
    left: 0;
    bottom: 0;
    border-bottom: 1px solid ${({ theme }) => theme.color.wartsilaGrey};
    border-right: 1px solid ${({ theme }) => theme.color.wartsilaGrey};
    transform: skew(-30deg) translate(-141px, 36px);
  }

  &:after {
    content: '';
    display: none;
    position: absolute;
    width: 150px;
    left: 0;
    bottom: 0;
    transform: translate(-170px, 37px);
    height: 110px;
    background-size: 132px 80px;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-image: url(${Logo});
  }

  ${({ theme, direction }) =>
    direction === 'right' &&
    `
      &:before {
        left: auto;
        right: 0;
        border-right: none;
        border-left: 1px solid ${theme.color.wartsilaGrey};
        transform: skew(30deg) translate(141px, 36px);
      }

      &:after {
        right: 0;
        left: auto;
        transform: translate(170px, 37px);
      }
  `}

  ${({ theme }) => media.md`
    border-bottom: 1px solid ${theme.color.wartsilaGrey};
    flex-direction: row;

    &:before, &:after {
      display: block;
    }
  `}

  ${({ animated }) =>
    animated &&
    css`
      &:before,
      &:after {
        ${blink}
      }
    `}
`

export const Support = styled.div`
  display: inline-flex;
  width: 100%;
  height: 55px;
  align-items: center;
  justify-content: center;

  &:before {
    content: '';
    display: block;
    height: 40px;
    width: 66px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-image: url(${Logo});
  }

  ${media.md`
    height: 35px;

    &:before, &:after {
      display: none;
    }
  `}
`

export const SupportLinkWrapper = styled.div`
  ${({ theme }) => `
    padding: 0 ${theme.space.mobile.large};
  `}
`
